import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ModalInterface} from '../../modal.interface';
import {concat, Observable, of, Subject} from 'rxjs';
import {ModalStateEvent} from '../../modal-state-event';
import {TokenDataProviderService} from '../../../../core/services/token-data-provider.service';
import {CurrentUserViewModel} from '../../../../core/models/current-user.view-model';
import {Store} from '@ngrx/store';
import {delay, map, mergeMap} from 'rxjs/operators';
import {AppState} from '../../../../state/app.state';
import {UserApiModel} from '../../../../api/models/user.api-model';
import {QueryParamsApiModel} from '../../../../api/models/query-params-api.model';
import {FilterParameterApiModel} from '../../../../api/models/filter-parameter.api.model';
import {UserRestService} from '../../../../api/services/user.rest.service';
import {ResultListApiModel} from '../../../../api/models/result-list.api.model';
import {UserDataProviderService} from '../../../../features/user/settings/user.data-provider.service';
import {MediaObjectApiModel} from '../../../../api/models/media-object.api-model';
import {MediaObjectViewModel} from '../../../../core/models/media-object.view-model';
import {MediaObjectRestService} from '../../../../api/services/media-object.rest.service';
import {Router} from '@angular/router';
import {ModalState} from '../../modal-state.enum';
import {LoaderService} from '../../../../core/services/loader.service';
import {ParticipantApiModel} from "../../../../api/models/participant.api.model";
import {FollowerListItemInterface} from "../../../../core/interfaces/follower-item.interface";
import {PersonalInformationApiModel} from "../../../../api/models/personal-information.api.model";
import {ModalComponent} from "../../modal.component";
import {AbstractComponent} from "../../../../core/components/abstract-component";
import {SocialDataProviderService} from "../../../timeline/social-grid-list/social-data-provider.service";
import {FollowApiModel} from "../../../../api/models/follow.api-model";
import {UserViewModel} from "../../../../features/user/settings/user.view-model";


@Component({
  selector: 'app-participation-list',
  templateUrl: './participation-list.component.html',
  styleUrls: ['./participation-list.component.scss'],
  providers: [UserDataProviderService]
})
export class ParticipationListComponent extends AbstractComponent implements OnInit, AfterViewInit, ModalInterface, OnDestroy {

  public currentUser: CurrentUserViewModel;
  public observeState: string;
  private followByUserId = new Map<string, FollowApiModel>();
  private followStateByUserId = new Map<string, 'pending' | 'filled'>();

  @Input() data: {participantAMs: ParticipantApiModel[], state: ('TAKES_PART' | 'INTERESTED' | 'ORGANIZES')[]};
  public state: Observable<ModalStateEvent>;
  public subject: Subject<ModalStateEvent>;
  private _participants: Observable<ParticipantApiModel[]>;
  public scrollerHeight: string = '60vh';
  private heightTimeoutId: ReturnType<typeof setTimeout> | null = null;

  get participants(): Observable<ParticipantApiModel[]> {
    return this._participants;
  }

  constructor(private tokenDPS: TokenDataProviderService,
              private userRS: UserRestService,
              private mediaRS: MediaObjectRestService,
              private store: Store<AppState>,
              private router: Router,
              private ls: LoaderService,
              private readonly modalComponent: ModalComponent,
              private readonly cdr: ChangeDetectorRef,
              private readonly socialDPS: SocialDataProviderService
  ) {
    super();
  }

  ngOnInit() {
    this.tokenDPS.currentUser.subscribe((currentUser: CurrentUserViewModel) => {
      this.currentUser = currentUser;
      if (!this.currentUser?.['@id']) {
        return;
      }
      this.subscriptions.push(
        this.socialDPS.fetchCurrentUserFollows(this.currentUser).subscribe((resultListAM: ResultListApiModel<FollowApiModel>) => {
          const map = new Map<string, FollowApiModel>();
          resultListAM.records.forEach((follow) => {
            const followedId = (follow.followed as any)?.['@id'];
            if (followedId) {
              map.set(followedId, follow);
            }
          });
          this.followByUserId = map;
          this.cdr.markForCheck();
        })
      );
    });
    const baseParticipants = this.data?.participantAMs || [];
    const participants = of(baseParticipants).pipe(delay(500), mergeMap((participantAMs: ParticipantApiModel[]) => {
      // const params = new QueryParamsApiModel();
      // const mediaIds = participantAMs.map(e => {
      //   const data = e.data as UserApiModel;
      //   return data.avatar;
      // });
      // for (const i of mediaIds) {
      //   params.filters.push(new FilterParameterApiModel('id', i));
      // }
      //
      // if (params.filters.length) {
      //   return this.mediaRS.getMediaObjectCollection(params).pipe(map((resultListAM: ResultListApiModel<MediaObjectApiModel>) => {
      //     return participantAMs.map((i: ParticipantApiModel) => {
      //       const avatar = resultListAM.records.find(e => {
      //         e['@id'] === i['data']['avatar'];
      //       });
      //       i = Object.assign({...i, data: {...i.data as UserApiModel, avatar: new MediaObjectViewModel(avatar)}});
      //       return i;
      //     });
      //   }));
      // }
      const stateList = new Set((this.data?.state || []).map((state) => String(state).toUpperCase()));
      const filtered = stateList.size
        ? participantAMs.filter(e => stateList.has(String(e.state).toUpperCase()))
        : participantAMs;
      const source = filtered.length ? filtered : participantAMs;
      return this.enrichParticipants(source);
    }));

    const placeholders = Array.from({length: 6}).map(() => {
      return Object.assign(new ParticipantApiModel(), {isPlaceholder: true});
    });
    this._participants = concat(of<ParticipantApiModel[]>(placeholders), participants);
  }

  ngAfterViewInit(): void {
    this.scheduleHeightUpdate();
    console.log(this.height);
  }

  @HostListener('window:resize')
  onResize(): void {
    this.scheduleHeightUpdate();
  }

  private scheduleHeightUpdate(): void {
    if (this.heightTimeoutId) {
      clearTimeout(this.heightTimeoutId);
    }
    this.heightTimeoutId = setTimeout(() => {
      const parentHeight = this.parentDiv?.nativeElement?.clientHeight || 0;
      const dialogHeight = this.modalComponent.dialogHeight();
      const contentEl = this.parentDiv?.nativeElement?.closest('.p-dialog-content') as HTMLElement | null;
      let baseHeight = contentEl?.clientHeight || parentHeight || (dialogHeight ? dialogHeight - 150 : 0);
      if (contentEl && typeof window !== 'undefined') {
        const styles = window.getComputedStyle(contentEl);
        const paddingTop = Number.parseFloat(styles.paddingTop || '0') || 0;
        const paddingBottom = Number.parseFloat(styles.paddingBottom || '0') || 0;
        baseHeight -= paddingTop + paddingBottom;
      }
      if (!baseHeight) {
        return;
      }
      const height = Math.max(baseHeight, 240);
      const nextHeight = `${height}px`;
      if (nextHeight !== this.scrollerHeight) {
        this.scrollerHeight = nextHeight;
        this.cdr.detectChanges();
      }
    }, 0);
  }

  postFollowing(following: FollowerListItemInterface) {
    if (!this.ensureLoggedIn()) {
      return;
    }
    const participant = following as unknown as ParticipantApiModel;
    const userVM = this.toUserVM(participant);
    if (!userVM) {
      return;
    }
    const userId = userVM['@id'];
    if (userId) {
      this.followStateByUserId.set(userId, 'pending');
    }
    this.socialDPS.postFollow(userVM).subscribe({
      next: (updatedVM: UserViewModel) => {
        const follow = updatedVM.receivedFollows?.[0] as FollowApiModel | undefined;
        if (userId) {
          if (follow) {
            this.followByUserId.set(userId, follow);
          }
          this.followStateByUserId.set(userId, 'filled');
        }
        this.cdr.markForCheck();
      },
      error: () => {
        if (userId) {
          this.followStateByUserId.delete(userId);
        }
      }
    });
  }

  removeFollowing(following: FollowerListItemInterface) {
    if (!this.ensureLoggedIn()) {
      return;
    }
    const participant = following as unknown as ParticipantApiModel;
    const userVM = this.toUserVM(participant);
    if (!userVM) {
      return;
    }
    const userId = userVM['@id'];
    const follow = userId ? this.followByUserId.get(userId) : null;
    if (!follow) {
      return;
    }
    if (userId) {
      this.followStateByUserId.set(userId, 'pending');
    }
    this.socialDPS.removeFollow(follow, userVM).subscribe({
      next: () => {
        if (userId) {
          this.followByUserId.delete(userId);
          this.followStateByUserId.delete(userId);
        }
        this.cdr.markForCheck();
      },
      error: () => {
        if (userId) {
          this.followStateByUserId.delete(userId);
        }
      }
    });
  }

  navigateToProfile(participant: ParticipantApiModel): void {
    this.ls.show();
    this.router.navigate(['/', participant.data['slug'], 'profile']).then(() => {
      this.subject.next(new ModalStateEvent(ModalState.SUCCESS));
    });
  }

  get parentModalRendered(): boolean {
    return this.modalComponent.rendered;
  }


  isPlaceholder(participant: ParticipantApiModel): boolean {
    return !!participant && (participant as any).isPlaceholder === true;
  }

  getParticipantUsername(participant: ParticipantApiModel): string {
    const data: any = participant?.data;
    if (typeof data === 'string') {
      return data.split('/').pop() || '';
    }
    return data?.username || data?.identity || data?.alias || data?.slug || '';
  }

  getParticipantFullName(participant: ParticipantApiModel): string | null {
    const data: any = participant?.data;
    const publicName = typeof data?.name === 'string' ? data.name.trim() : '';
    if (publicName && publicName !== data?.username) {
      return publicName;
    }
    const info = data?.info as PersonalInformationApiModel | string | undefined;
    if (!data?.settings?.privacy?.nameVisible || !info || typeof info === 'string') {
      return null;
    }
    const firstName = info?.firstName || '';
    const lastName = info?.lastName || '';
    const fullName = `${firstName} ${lastName}`.trim();
    return fullName.length ? fullName : null;
  }

  private enrichParticipants(participants: ParticipantApiModel[]): Observable<ParticipantApiModel[]> {
    const slugs = participants
      .map((participant) => this.getParticipantSlug(participant))
      .filter((slug): slug is string => !!slug);

    if (!slugs.length) {
      return of(participants);
    }

    const params = new QueryParamsApiModel();
    slugs.forEach((slug) => {
      params.filters.push(new FilterParameterApiModel('slug', slug));
    });

    return this.userRS.getCollection(params).pipe(mergeMap((resultListAM: ResultListApiModel<UserApiModel>) => {
      const enriched = participants.map((participant) => {
        const slug = this.getParticipantSlug(participant);
        const user = resultListAM.records.find(u => u.slug === slug || u['@id'] === (participant.data as any)?.['@id']);
        if (!user) {
          return participant;
        }
        return Object.assign(new ParticipantApiModel(), participant, {data: user});
      });
      const mediaParams = new QueryParamsApiModel();
      enriched.forEach((participant) => {
        const user = participant.data as UserApiModel;
        const avatarId = user?.avatar && (user.avatar as any)['@id'] || user?.avatar;
        if (avatarId) {
          mediaParams.filters.push(new FilterParameterApiModel('id', avatarId));
        }
      });
      if (!mediaParams.filters.length) {
        return of(enriched);
      }
      return this.mediaRS.getMediaObjectCollection(mediaParams).pipe(map((resultList: ResultListApiModel<MediaObjectApiModel>) => {
        return enriched.map((participant) => {
          const user = participant.data as UserApiModel;
          const avatarId = user?.avatar && (user.avatar as any)['@id'] || user?.avatar;
          const avatar = resultList.records.find((media) => media['@id'] === avatarId);
          if (avatar) {
            const nextUser = Object.assign({}, user, {avatar: new MediaObjectViewModel(avatar)});
            return Object.assign(new ParticipantApiModel(), participant, {data: nextUser});
          }
          return participant;
        });
      }));
    }));
  }

  private getParticipantSlug(participant: ParticipantApiModel): string | null {
    const data: any = participant?.data;
    if (typeof data === 'string') {
      return data.split('/').pop() || null;
    }
    return data?.slug || data?.username || null;
  }

  getFollowState(participant: ParticipantApiModel): 'pending' | 'filled' | '' {
    const userId = (participant?.data as any)?.['@id'];
    if (userId && this.followStateByUserId.has(userId)) {
      return this.followStateByUserId.get(userId);
    }
    return userId && this.followByUserId.has(userId) ? 'filled' : '';
  }

  isFollowButtonVisible(participant: ParticipantApiModel): boolean {
    const userId = (participant?.data as any)?.['@id'];
    return !!userId && this.currentUser?.['@id'] && userId !== this.currentUser['@id'];
  }

  private toUserVM(participant: ParticipantApiModel): UserViewModel | null {
    const data = participant?.data;
    if (!data || typeof data === 'string') {
      return null;
    }
    return new UserViewModel(data as UserApiModel);
  }

  private ensureLoggedIn(): boolean {
    if (!this.tokenDPS.isLoggedIn()) {
      this.router.navigate(['/login']);
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    if (this.heightTimeoutId) {
      clearTimeout(this.heightTimeoutId);
    }
  }
}
